<div
  class="icon-marker"
  [style.width.px]="sizeMarker()"
  [style.height.px]="sizeMarker()"
  [style.transform]="getRotation()"
  [class.shadow]="displayShadow"
  [class.ignition-on]="isOn"
  [class.ignition-off]="!isOn"
  [class.selected]="selected">
  <vdo-icon
    [svgIcon]="icon()"
    [width]="sizeIcon()"
    [height]="sizeIcon()"></vdo-icon>
  @if (!isOn && displayFloatingIcon()) {
    <div>
      <vdo-icon
        class="icon-off"
        svgIcon="on-error"
        [width]="16"
        [height]="16"></vdo-icon>
    </div>
  }
</div>
